import { render, staticRenderFns } from "./AdminButton.vue?vue&type=template&id=075e8df6"
import script from "./AdminButton.vue?vue&type=script&lang=js"
export * from "./AdminButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports